import _ from 'underscore';

export function maybeUpdate<T>(existing: _.Dictionary<T>, key: string, value: T): _.Dictionary<T> {
  if (existing) {
    if (existing[key] === value) {
      return existing;
    } else {
      return _.defaults({
        [key]: value
      }, existing);
    }
  } else {
    return {
      [key]: value
    };
  }
}
